var _pattern, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _polygon2, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _rect18, _rect19, _path2, _path3, _path4, _polygon3, _rect20, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthquake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    id: "earthquake",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 8.814,
    height: 8.814,
    y: -1190,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -8.814 8.814 8.814"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "0 0 8.814 0 8.814 -8.814 0 -8.814"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#88603F",
    points: "8.814 0 0 0 0 -8.814 8.814 -8.814"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "30.626 4.765 30.626 12.485 23.846 12.485 23.846 47.405 4.646 47.405 4.646 21.865 5.186 21.235 4.646 20.605 4.646 18.385 5.386 17.645 4.646 16.895 4.646 4.765"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 7.029,
    y: 8.515,
    fill: "#4A8BC9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 14.733,
    y: 8.515,
    fill: "#4A8BC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 22.437,
    y: 8.515,
    fill: "#4A8BC9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 7.029,
    y: 16.616,
    fill: "#4A8BC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 14.733,
    y: 16.616,
    fill: "#4A8BC9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 22.437,
    y: 16.616,
    fill: "#4A8BC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 7.029,
    y: 24.717,
    fill: "#4A8BC9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 14.733,
    y: 24.717,
    fill: "#4A8BC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.7,
    height: 4.959,
    x: 22.437,
    y: 24.717,
    fill: "#4A8BC9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "45.836 20.485 44.526 21.785 45.836 23.115 45.836 24.425 45.356 25.005 45.836 25.595 45.836 46.325 23.846 46.325 23.846 12.485 45.836 12.485"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 29.42,
    height: 3.83,
    x: 2.926,
    y: 0.935,
    fill: "#D25C59"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 26.181,
    y: 15.813,
    fill: "#FCCC67"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 32.816,
    y: 15.813,
    fill: "#FCCC67"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 39.452,
    y: 15.813,
    fill: "#FCCC67"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 26.181,
    y: 22.989,
    fill: "#FCCC67"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 32.816,
    y: 22.989,
    fill: "#FCCC67"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 39.452,
    y: 22.989,
    fill: "#FCCC67"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 26.181,
    y: 30.166,
    fill: "#FCCC67"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 32.816,
    y: 30.166,
    fill: "#FCCC67"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.049,
    height: 4.049,
    x: 39.452,
    y: 30.166,
    fill: "#FCCC67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M48.1489,49.065H1.8511c-0.5522,0-1-0.4478-1-1s0.4478-1,1-1h46.2979 c0.5522,0,1,0.4478,1,1S48.7012,49.065,48.1489,49.065z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 9.876,
    height: 11.945,
    x: 12.698,
    y: 35.12,
    fill: "#676767"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 6.2,
    height: 8.841,
    x: 31.741,
    y: 37.484,
    fill: "#BB302F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CCC65",
    d: "M48.2457,46.8266c0,0.0795-0.01,0.1589-0.02,0.2384h-35.37c-2.2547-1.3622-0.4663-3.5408,2.7-3.5583 c-0.1-0.2157-0.15-0.4483-0.15-0.681c0-3.6614,9.5425-3.7022,10.02-0.3859c0.56-0.1419,1.11-0.0567,1.77-0.0567 c2.17,0,4,0.8285,4.55,1.9635c0.5199-3.4336,9.4249-3.4132,9.92,0.0114C44.2411,43.717,48.2457,44.6077,48.2457,46.8266z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB302F",
    d: "M39.2357,21.005c-0.3751,1.6279-1.9505,8.4661-1.85,8.03l1.13-7.96c-0.051-0.1054-1.4565-3.0088-1.37-2.83 c0.0208-0.1006,1.2691-6.1427,1.19-5.76h1.48l-1.67,5.68C38.1855,18.2686,39.3069,21.1904,39.2357,21.005z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M13.2457,7.955c0.0176,0.1001,1.0877,6.1748,1.02,5.79c-0.1728,0.9294-1.4518,7.81-1.37,7.37l1.05,3.9 l-1.43-3.82l-0.02-0.04l0.0099-0.05l0.9901-7.34c-0.0229-0.1001-1.4383-6.2964-1.35-5.91c0.3942-1.1174,1.1311-3.2064,1.09-3.09 l1.35-3.83h1.54C16.0845,1.0356,13.0566,8.416,13.2457,7.955z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9A2B2A",
    points: "16.126 .935 14.556 4.765 13.236 4.765 14.586 .935"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 24.01,
    height: 2.794,
    x: 22.836,
    y: 9.691,
    fill: "#676767"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "48.493 24.149 47.443 25.192 46.399 24.135 47.449 23.092"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "47.391 26.236 46.712 27.028 46.036 26.226 46.716 25.435"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "48.847 27.116 48.38 27.66 47.916 27.109 48.383 26.565"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "47.33 28.437 46.863 28.981 46.399 28.43 46.866 27.886"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "48.206 29.601 47.739 30.145 47.275 29.594 47.742 29.05"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "47.391 31.202 46.924 31.746 46.46 31.195 46.927 30.651"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "48.597 31.833 48.13 32.377 47.666 31.826 48.133 31.282"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "47.59 32.928 47.123 33.472 46.659 32.921 47.126 32.377"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE7373",
    points: "48.597 33.677 48.13 34.163 47.666 33.671 48.133 33.185"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "2.9 20.223 2.114 21.139 1.333 20.211 2.119 19.295"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "4.557 19.101 3.771 20.017 2.989 19.09 3.776 18.173"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "4.585 21.24 4.045 21.869 3.508 21.232 4.048 20.602"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "2.83 22.769 2.289 23.398 1.752 22.761 2.293 22.131"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "3.761 24.399 2.97 24.65 2.849 23.825 3.64 23.574"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "2.9 25.968 2.36 26.598 1.823 25.96 2.363 25.331"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "4.226 26.96 3.448 27.248 3.288 26.43 4.066 26.142"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "2.672 27.799 2.354 28.565 1.646 28.126 1.964 27.36"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CDCCCC",
    points: "4.296 28.833 3.756 29.395 3.219 28.826 3.759 28.264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake);
export default __webpack_public_path__ + "static/media/earthquake.34c8c7d8ad8457a452edfbcdab97ec13.svg";
export { ForwardRef as ReactComponent };